import React, { useState, useEffect, useContext } from 'react'
import io from 'socket.io-client'
import { useUser } from '../../data/user'
let socket
const makeSocket = (roomName) => {
    const socketIOOptions = {
        // autoConnect: false,
        query: { token: window.localStorage.getItem('token'), roomName },
    }
    if (socket) {
        return socket
    }
    socket = process.env.REACT_APP_WS_URL
        ? io(
              process.env.REACT_APP_WS_URL || 'ws://localhost:8344',
              socketIOOptions
              // { transports: ['polling'] }
          )
        : io(socketIOOptions)
    return socket
}
export const SocketContext = React.createContext(null)

export const useChatRooms = (roomName) => {
    const socketContext = useContext(SocketContext)
    useEffect(() => {
        if (roomName) {
            socketContext.setActiveChat(roomName)
        }
    }, [roomName])
    return { ...socketContext }
}
export const SocketContextProvider = (props) => {
    const [socket, setSocket] = useState(makeSocket())
    const [{ activeUser }] = useUser()
    const [chatRooms, setChatRooms] = useState({})
    const [activeChat, setActiveChat] = useState()
    const [isConnected, setIsConnected] = useState()
    useEffect(() => {
        if (!isConnected) {
        }
        socket.on('connect', () => {
            setIsConnected(true)
        })

        socket.on('disconnect', (reason) => {
            if (['io server disconnect', 'transport close'].includes(reason)) {
                setTimeout(socket.connect, 500)
            }
            setIsConnected(false)
        })
        socket.on('error', (error) => {
            console.error(error)
        })
        socket.on('message', (incomingMessage) => {
            const { message, roomName } = incomingMessage

            setChatRooms((chatRooms) => {
                const room = chatRooms[roomName]
                return {
                    ...chatRooms,
                    [roomName]: {
                        ...room,
                        messages: [...(room?.messages || []), incomingMessage],
                    },
                }
            })
        })
        socket.on('room_joined', (room) => {
            if (!room) return
            setChatRooms((rooms) => ({
                ...rooms,
                [room?.name]: room,
            }))
        })
        return () => {
            socket.off('connect')
            socket.off('message')
            socket.off('room_joined')
            socket.off('disconnect')
        }
    }, [isConnected])
    useEffect(() => {
        if (!activeUser) {
            socket.disconnect()
            socket.off('connect')
            socket.off('message')
            socket.off('room_joined')
            socket.off('disconnect')
        } else if (activeUser && !socket.connected) {
            socket.connect()
        }
    }, [activeUser])
    useEffect(() => {
        if (activeChat) {
            !socket.connected && socket.connect()
            socket.emit('room_join', { roomName: activeChat })
        } else {
            socket.disconnect()
        }
    }, [activeChat])
    const sendMessage = (message) => {
        socket.emit('userMessage', { message, roomName: activeChat })
    }
    return (
        <SocketContext.Provider
            value={{
                chatRooms,
                sendMessage,
                setActiveChat,
                activeChat,
                isConnected,
            }}
        >
            {props.children}
        </SocketContext.Provider>
    )
}
